import React from 'react';
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";

const ProjectsCard = ({ project }) => {
  const { title, description, role, image_url, url, github_url } = project;

  return (
    <div className="w-full p-4 xl:px-12 h-auto xl:py-10 rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:to-gray-900 transition-all duration-300 card-border">

      {/* IMAGE FIX */}
      <div className="w-full aspect-[1] overflow-hidden rounded-lg">
        <img
          className="w-full h-full object-cover group-hover:scale-110 duration-300 cursor-pointer"
          src={image_url || "https://via.placeholder.com/400x300?text=No+Image"}
          alt={title}
        />
      </div>

      <div className="w-full mt-5 flex flex-col gap-4">
        <div>
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-bold text-designColor">{title}</h3>

            <div className="flex gap-2">
              {url && (
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300"
                >
                  <FaGlobe />
                </a>
              )}

              {github_url && (
                <a
                  href={github_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300"
                >
                  <BsGithub />
                </a>
              )}
            </div>
          </div>

          {role && (
            <p className="text-sm text-gray-400 mt-1 italic">{role}</p>
          )}

          <p className="text-sm tracking-wide mt-3 text-gray-300 leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProjectsCard;